import { styled } from '@mui/material';

export const sxStyles = {
  listActionsStart: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: { xs: 0, sm: '1.5rem' },
  },
  schoolsBg: {
    backgroundColor: '#F9F9F9',
  },
  mainSectionWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2rem',
  },
  mainSectionContent: {
    maxWidth: '952px',
    width: '100%',
    minHeight: '452px',
  },
};

export const StyledFullRow = styled('div')(() => ({
  gridColumn: '1 / -1',
  width: '100%',
}));

export const StyledMainSectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginBottom: '2rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  [theme.breakpoints.up('sm')]: {
    marginBottom: '1.5rem',
  },
}));

export const StyledCardViewSwitcherWrap = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',

  [theme.breakpoints.up('sm')]: {
    position: 'static',
    overflow: 'visible',
    visibility: 'visible',
    width: 'auto',
    height: 'auto',
  },
}));

export const StyledSchoolCardsWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isGridView',
})<{ isGridView: boolean }>(({ theme, isGridView }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.down('md')]: {
    gap: '2rem 3rem',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },

  ...(isGridView && {
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(272px, 1fr))',
    },
  }),
}));

export const StyledDesktopFiltersWrap = styled('div')(({ theme }) => ({
  width: 'auto',
  overflow: 'visible',
  visibility: 'visible',
  height: 'auto',

  [theme.breakpoints.down('md')]: {
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    visibility: 'hidden',
  },
}));

export const StyledBottomPaginationWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginTop: '1.5rem',
  gridColumn: '1 / -1',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
  },

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'space-between',
  },
}));
